export default function(float: number, decimals: number) {
    const magnitude = Math.pow(10, decimals);
    const int = float * magnitude;
    const rounded = Math.round(int) / magnitude;
    return rounded.toString();
}


// WEBPACK FOOTER //
// ./src/utils/floatToString.ts